// ARPA syllabification (ARPABET)

// Unused (kept for the future) export const VOICED = new Set<string>([ "G", "B", "D", "DH", "V", "Z", "ZH", "JH", "DX", ]);

export const VOICELESS = new Set<string>([
  "K",
  "P",
  "T",
  "F",
  "HH",
  "S",
  "SH",
  "TH",
  "CH",
  "TR",
]);

export const STOPS = new Set<string>(["K", "P", "T", "G", "B", "D", "DX"]);

export const FRICATIVES = new Set<string>([
  "F",
  "DH",
  "HH",
  "S",
  "SH",
  "TH",
  "V",
  "Z",
  "ZH",
]);

export const AFFRICATES = new Set<string>(["CH", "JH"]);

export const NASALS = new Set<string>(["M", "N", "NG"]);

export const APPROXIMANTS = new Set<string>(["L", "R", "W", "Y"]);

export const PHONESET = new Set<string>([
  "CL",
  "Q",
  "VF",
  "AA",
  "AE",
  "AH",
  "AO",
  "AW",
  "AX",
  "AY",
  "B",
  "CH",
  "D",
  "DR",
  "DH",
  "EH",
  "ER",
  "EY",
  "F",
  "G",
  "HH",
  "IH",
  "IY",
  "JH",
  "K",
  "L",
  "M",
  "N",
  "NG",
  "OW",
  "OY",
  "P",
  "R",
  "S",
  "SH",
  "T",
  "TR",
  "TH",
  "UH",
  "UW",
  "V",
  "W",
  "Y",
  "Z",
  "ZH",
  "DX",
]);

// Vowel symbols may have stress digit 0-2 (e.g. AA1)
export const BASE_VOWELS = new Set<string>([
  "AA",
  "AE",
  "AH",
  "AO",
  "AW",
  "AX",
  "AY",
  "EH",
  "ER",
  "EY",
  "IH",
  "IY",
  "OW",
  "OY",
  "UW",
  "UH",
]);
